import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import state from "./state";

const therapieModule = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}

export default therapieModule